/**
 * Status pill for circular loops.
 * State is communicated through the text label, not just colour — WCAG-friendly.
 *
 * @param {Object} props
 * @param {"running" | "building"} props.status
 * @param {string} props.label
 * @param {string} [props.className]
 */
const StatusPill = ({ status, label, className = "" }) => {
  const base =
    "inline-flex items-center gap-2 text-[10px] md:text-[11px] font-semibold tracking-[0.18em] uppercase px-3 py-1.5 rounded-full whitespace-nowrap";

  const tone =
    status === "running"
      ? "bg-ecospora-green-deep text-ecospora-cream"
      : "border border-ecospora-green-deep/40 text-ecospora-green-mid bg-ecospora-cream/40";

  return (
    <span
      data-testid={`status-pill-${status}`}
      className={`${base} ${tone} ${className}`}
    >
      <span
        aria-hidden="true"
        className={`w-1.5 h-1.5 rounded-full ${
          status === "running" ? "bg-ecospora-ochre" : "bg-ecospora-green-mid"
        }`}
      />
      {label}
    </span>
  );
};

export default StatusPill;
